import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-add-vendor-adjustment-trips',
  templateUrl: './add-vendor-adjustment-trips.component.html',
  styleUrls: ['./add-vendor-adjustment-trips.component.scss']
})
export class AddVendorAdjustmentTripsComponent {

  public _mFormGroup: FormGroup;
  public mUserName = new FormControl("", Validators.required);
  public mEmployeeId = new FormControl();
  public mSites = new FormControl("", Validators.required);
  public mApproxKm = new FormControl("", Validators.required);
  public mTravelDate = new FormControl(new Date(), Validators.required);
  public mLogType = new FormControl("", Validators.required);
  public mNearestShiftTime = new FormControl("", Validators.required);
  public mEscortRequired = new FormControl(false, Validators.required);
  public mEscort = new FormControl("", Validators.required);
  public mReason = new FormControl("");
  public mVehicleNumber = new FormControl("", Validators.required);
  public mVehicleType = new FormControl("", Validators.required);
  public mVendor = new FormControl("", Validators.required);
  public mDriverName = new FormControl("", Validators.required);

  _mSitesData: any = [];
  _mVendors: any = [];
  _mEscort: any[] = [];
  _mBookingTypes: any[] = [];
  currentUserInfo: any = '';
  _BookedForUser: any;
  _mVehicleTypes: any[] = [];
  pastDate = new Date();
  toDatePickerMin = new Date(new Date().setDate(this.pastDate.getDate() - 30));
  max = new Date();
  toDatePickerMax = new Date(new Date().setDate(this.max.getDate() - 0));
  user: any[] = [];
  reportingTimes: any[] = [];
  nearestShiftTime =
    new Date(this.mTravelDate.value).getHours() +
    "" +
    new Date(this.mTravelDate.value).getMinutes();
  empSearchFlag: boolean = false;
  _driverList: any[] = [];
  mVehicleLists: any = [];
  logType = [
    { key: "IN", value: "IN" },
    { key: "OUT", value: "OUT" }
  ];

  constructor(
    private fb: FormBuilder,
    private serviceLocalStorage: ServiceLocalStorage,
    public dialogRef: MatDialogRef<AddVendorAdjustmentTripsComponent>,
    public dialog: MatDialog,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    // @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this._mFormGroup = this.fb.group({
      userName: this.mUserName,
      employeeId: this.mEmployeeId,
      site: this.mSites,
      travelDate: this.mTravelDate,
      logType: this.mLogType,
      approxKm: this.mApproxKm,
      nearestShiftTime: this.mNearestShiftTime,
      escortRequired: this.mEscortRequired,
      reason: this.mReason,
      vehicleType: this.mVehicleType,
      vendor: this.mVendor,
      escort: this.mEscort,
      driverName: this.mDriverName,
      vehicleNumber: this.mVehicleNumber
    });

    this.getSites();
    this.getBookingTypes();
    this.getTime();
    this.currentUserInfo = this.serviceLocalStorage.getUserObject();
    this.mEmployeeId.disable();
    this.onEscortToggle();
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    this.nearestShiftTime = hours + minutes;
  }

  getSerchUser($event) {
    const searchKey = $event.target.value;
    if (searchKey.length < 3) return;
    const spocId = this.currentUserInfo.userInfoDetails.role.name === 'SPOC'
      ? this.currentUserInfo.id
      : 0;
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getuserbyfirstnameforvendor + '?searchkey=' + searchKey + '&spocId=' + spocId,
      success => {
        this.empSearchFlag = false;
        this.user = success.body;
      },
      error => {
        this.empSearchFlag = false;
      }
    );
  }

  onSiteChange(option) {
    const siteId = +option.target.value;
    this.mVendor.setValue('');
    this.mEscort.setValue('');
    this.getVendorBySite(siteId);
    this.getEscortListBySite(siteId);
    this.getVehicleTypes(siteId);
  }

  getSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getsitesbyuserid,
      success => {
        if (success.status == 200) {
          this._mSitesData = success.body;
        } else {
          this._mSitesData = [];
          this.notifyService.showInfo("No Sites Found", null);
        }
      },
      error => {
      }
    );
  }

  onVehicleChanges(type) {
    this.mVehicleNumber.setValue(type.registrationNo);
    this.getDriverList(type.id);
  }

  getDriverList(vehicleId) {
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getDriverListByVehicleId + vehicleId,
      success => {
        this._driverList = success.status === 200 ? success.body : [];
        if (success.status !== 200) {
          this.notifyService.showInfo("No drivers found", null);
        }
      },
      error => this.notifyService.showError("Error in getting drivers", null)
    );
  }

  getBookingTypes() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getSpecialbookingType,
      success => {
        if (success.status == 200) {
          this._mBookingTypes = success.body;
        } else {
          this._mBookingTypes = [];
          this.notifyService.showInfo("No Booking Types Found", null);
        }
      },
      error => {
      }
    );
  }

  onEscortToggle() {
    this.mEscortRequired.value ? this.mEscort.enable() : (this.mEscort.disable(), this.mEscort.setValue(""));
  }

  searchSubmit(option) {
    const siteId = this._mSitesData.length > 1 ? option.userInfoDetails.site.siteId : this._mSitesData[0].siteId;
    this.mEmployeeId.setValue(option.userInfoDetails.employeeId);
    this.mSites.setValue(siteId);
    this.getVendorBySite(siteId);
    this.getEscortListBySite(siteId);
    this.getVehicleTypes(siteId);
    this._BookedForUser = option;
  }

  getVendorBySite(siteId) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllVendorDropDownBasedOnSiteAndUser + siteId, success => {
      if (success.status == 200) {
        this._mVendors = success.body;
      } else {
        this._mVendors = [];
        this.notifyService.showInfo("No Vendors Found", null);
      }
    },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  vehicleSearch($event) {
    const searchKey = $event.target.value;
    if (searchKey.length < 3) return;
    if (!this.mVendor.value) {
      this.notifyService.showWarning("Please select vendor", null);
      return;
    }
    if (!this.mVehicleType.value) {
      this.notifyService.showWarning("Please select vehicle type", null);
      return;
    }

    const endpoint = `${ApiConstants.getVehicleListBySiteVendorMasterIdAndVehicleType}${this.mSites.value}&vendorMasterId=${this.mVendor.value}&vehicleTypeId=${this.mVehicleType.value}&searchkey=${searchKey}`;
    this.mVehicleLists = [];
    this.apiService.doGetRequestWithResponse(endpoint,
      success => {
        this.mVehicleLists = success.status === 200 ? success.body : [];
        if (success.status !== 200) {
          this.notifyService.showInfo("No vehicles found", null);
        }
      },
      () => console.error("Error fetching vehicle list")
    );
  }

  dateChanged() {
    const date = this.mTravelDate.value;
    const dateObj = date instanceof Date ? date : new Date(date);
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    this.nearestShiftTime = hours + minutes;
    this.mNearestShiftTime.setValue("");
    this.getTime();
  }

  getEscortListBySite(siteId) {
    this._mEscort = [];
    this.apiService.doGetRequestWithResponse(ApiConstants.getEscortListBySiteId + siteId, success => {
      if (success.status == 200) {
        this._mEscort = success.body;
      } else {
        this._mEscort = [];
        this.notifyService.showInfo("No Escort Found", null);
      }
    },
      error => {
      }
    );
  }

  getVehicleTypes(siteId) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleTypeBySite + "?siteId=" + siteId, success => {
      if (success.status == 200) {
        this._mVehicleTypes = success.body;
      } else {
        this.notifyService.showInfo("No Vehicles Found", null);
      }
    },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  getTime() {
    const currentTime = this.nearestShiftTime.toString();
    this.reportingTimes = AppConstants.reportingTimes.filter(element =>
      element.value.replace(':', '') > currentTime
    );
  }

  formatDatePickerDate(d) {
    let date = d.split("/");
    return date[1] + "/" + date[0] + "/" + date[2];
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return dt + "/" + mm + "/" + d.getFullYear();
  }

  omit_number(event) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 46);
  }

  onSubmit() {
    this._mFormGroup.markAllAsTouched();
    const isEscortRequired = this.mEscortRequired.value;
    const newData = {
      bookedFor: { id: this._BookedForUser.id },
      bookedBy: { id: this.currentUserInfo.id },
      escort: isEscortRequired ? { id: this.mEscort.value } : null,
      escortRequired: isEscortRequired ? "true" : "false",
      reason: this.mReason.value,
      pickDrop: this.mLogType.value,
      site: { siteId: this.mSites.value },
      vehicleType: { id: this.mVehicleType.value },
      vehicle: { id: this.mVehicleNumber.value },
      nearestTime: this.mNearestShiftTime.value,
      status: "SENT_FOR_ADMIN_APPROVAL",
      travelDate: this.formatDate(this.mTravelDate.value),
      driver: { id: this.mDriverName.value },
      approximateKm: +this.mApproxKm.value
    };

    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      ApiConstants.adjustmentTrip,
      newData,
      success => {
        this.ngxLoader.stop();
        if (success.status === 201) {
          this.dialogRef.close(success);
          this.notifyService.showSuccess(success.body.message, null);
        } else {
          this.notifyService.showWarning("Error while adding trips", null);
        }
      },
      () => this.ngxLoader.stop()
    );
  }

}
